module.exports = "//d274d294w9cx2v.cloudfront.net/c24674afd2553df9f6e362ffac40966d79cb698e/images/venmoBadge.png";